import history from './history';

class AwsHelper {  
  constructor() { 
    this.logout = this.logout.bind(this);    
    this.isAuthenticated = this.isAuthenticated.bind(this);
  }

  setSession(token) {        
    localStorage.setItem('id_token', token);    
    history.replace('/clients');
  }

  logout() {
    // Clear access token and ID token from local storage
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');    
  }

  isAuthenticated() {
    // Check whether the current time is past the
    // access token's expiry time
    return (
      new Date().getTime() < JSON.parse(localStorage.getItem('expires_at'))
    );
  }
}
export default new AwsHelper();
